import z from "zod";

export const timesheetExportDataSchema = z.object({});

export type TimesheetExportDataProps = z.infer<
  typeof timesheetExportDataSchema
>;
